export default __webpack_public_path__ + "static/media/KnowWho.8059c1dd.svg";